import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { clearCart, fetchCart, removeItem } from "../../Utils/Redux/CartSlice";
import SlideUpWrapper from "../../components/Transitions/SlideUpWrapper";
import { androidDelete } from 'react-icons-kit/ionicons/androidDelete'
import Icon from 'react-icons-kit';
import TopTitleBar from "../DashBoard/ExternalDash/TopTitleBar";
import { ADD_MONEY, BASE_URL, CONTINUE_AS_B2C, EMPTY_CART, PAYMENT_VIA_WALLET, REMOVE_FROM_CART, UPDATE_GSTIN, VERIFY_WALLET } from "../../Utils/constant";
import { MESSAGE } from "../../Utils/Strings";
import API from '../../ApiConfig'
import cogoToast from "cogo-toast-react-17-fix";
import useRazorpayPayment from "../../components/RazorPay/paymentGateway";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader";
import AnimatedLoader from "../../components/AnimationLoader";
import { androidArrowBack } from "react-icons-kit/ionicons/androidArrowBack";
import Navigate from "react-icons-kit";
import ReactPortalModal from "../../components/ReactPortalModal";
import { alertCircle } from 'react-icons-kit/feather/alertCircle'
import { AuthConsole } from "../../Utils/helper";
import AddDefaultGstIn from "../AddGstin/AddGSTIN";

const AddGstIn=({enterGstIn, setEnterGstIn, setGstinPopup})=>{


    const [gstinInput, setGstinInput]=useState("")
    const [confirmGstinInput, setConfirmGstIn]=useState("")
    const [loading, setLoading]=useState(false)

    const User=useSelector(state=>state.User)

    const[gstinError, setGstinError]=useState("")
    const [b2cError, setB2CError]=useState("")
    const onEnterGstin=()=>{
        setEnterGstIn(true)

    }
    const GstinCheck=()=>{
        if (gstinInput === "") {
            setGstinError("Enter GSTIN");
        } 
        else if (confirmGstinInput === "") {
            setGstinError("Confirm GSTIN");
        } 
        else if (gstinInput.length !== 15) {
            setGstinError("Enter valid GSTIN");
        } 
        else if (confirmGstinInput !== gstinInput) {
            setGstinError("Confirm GSTIN not matched, try again");
        }
        else{
            setGstinError("")
        setLoading(true)
        let apiData={
            user_id:User.user_id,
            gstin:gstinInput
        }
        API.put(UPDATE_GSTIN, apiData)
        .then(res=>{
            if(res.data.status==200){
                setLoading(false)
                setGstinPopup(false)
                setGstinInput("")
                setConfirmGstIn("")
            }
            
        })
        .catch(err=>{
            setLoading(false)
            setGstinError(err.response?.data?.message|| "Something went wrong")

        })}

    }

    const onD2C=()=>{
        setLoading(true)
        API.post(`${CONTINUE_AS_B2C}?user_id=${User.user_id}`)
        .then(res=>{
            if(res.data.status=200){
                setLoading(false)
                setB2CError("")
                setGstinPopup(false)
            }
        })
        .catch(err=>{
            setLoading(false)
            setB2CError(err.response.data.message)
            
        })
    }
    return(
        <div className="relative z-10 w-[28rem] max-w-full rounded-2xl bg-white p-6 shadow-lg">
            <Loader isOpen={loading}/>
    {!enterGstIn?(
    <>
    {b2cError&&
        <div
        style={{
          backgroundColor: "#fee2e2",
          color: "#b91c1c",
          padding: "0.75rem 1rem",
          borderRadius: "8px",
          marginBottom: "1rem",
          fontWeight: "500",
          textAlign: "center",
        }}
      >{b2cError}
      </div>

    }
    <header className="mb-4 flex items-start gap-3 items-center">
      <div className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-red-50 text-red-600">
        {/* icon */}
        <Icon icon={alertCircle} size={22}/>
      </div>
      <div className="flex-1">
        <h2 id="invalid-gstin-title" className="text-lg font-semibold">
          Invalid GSTIN
        </h2>
        {/* <p className="mt-1 text-sm text-slate-600">
          The GSTIN you entered{gstinDisplay ? ` (“${gstinDisplay}”)` : ""} is invalid. Please choose an action.
        </p> */}
      </div>
    </header>

    <div className="mb-4">
      <ul className="text-sm text-slate-600">
        <li style={{margin:"10px 0px"}}>Re-enter a correct 15-character GSTIN (example: 27ABCDE1234F1Z5)</li>
        <li>Or continue as B2C if you don’t have GSTIN</li>
      </ul>
    </div>

    <footer className="mt-6 flex justify-end gap-3">

      <button
        type="button"
        onClick={onEnterGstin}
        className="btn btn-primary"
      >
        Enter GSTIN
      </button>

      <button
        type="button"
        onClick={onD2C}
        className="rounded-md px-4 py-2 text-sm font-medium border border-slate-300 bg-white hover:bg-slate-50"
      >
        Continue as B2C
      </button>
    </footer>
    </>):(
        <>
{gstinError&&
<div
          style={{
            backgroundColor: "#fee2e2",
            color: "#b91c1c",
            padding: "0.75rem 1rem",
            borderRadius: "8px",
            marginBottom: "1rem",
            fontWeight: "500",
            textAlign: "center",
          }}
        >
          {gstinError}
        </div>}
    <header className="mb-4 flex items-center gap-3">
  <div className="flex-1">
    <div style={{margin:"10px 0px", display:"flex", alignItems:"center"}}>
    <span onClick={()=>{setEnterGstIn(false);setGstinError("");setGstinInput("");setConfirmGstIn("")}} style={{cursor:"pointer", marginRight:"7px"}}>
    <Icon icon={androidArrowBack} size={22}/>
    </span>
  <span className="text-lg text-slate-600">
    Please re-enter a valid 15-character GSTIN.
  </span>
  </div>
</div>
</header>

{/* GSTIN input */}
<div className="mb-4">
<label>Enter GSTIN</label>
<div style={{margin:"10px, 0px"}}>
<input
  type="text"
  value={gstinInput}
  onChange={(e) => {setGstinInput(e.target.value.toUpperCase());
    if(gstinError){
        setGstinError("")
    }
  }}
  placeholder="Enter GSTIN (e.g. 27ABCDE1234F1Z5)"
  maxLength={15}
  className="rounded-md border px-3 py-2 text-sm focus:outline-none"
  style={{width:"75%", margin:"4px 0px", border:"1px solid rgb(206,200,200)"}}
/>
{gstinInput.includes(" ") && (
  <p className="text-sm text-red-500">
    GSTIN cannot contain spaces.
  </p>
)}
</div>
</div>
<div className="mb-4">
<label>Confirm GSTIN</label>
<div>
<input
  type="text"
  value={confirmGstinInput}
  onChange={(e) => {setConfirmGstIn(e.target.value.toUpperCase());
    if(gstinError){
        setGstinError("")
    }
  }}
  placeholder="Confirm GSTIN.."
  maxLength={15}
  className="rounded-md border px-3 py-2 text-sm focus:outline-none"
  style={{width:"75%", margin:"4px 0px", border:"1px solid rgb(206, 200, 200)"}}
/>
</div>
{confirmGstinInput.includes(" ") && (
  <p className="text-sm text-red-500">
    GSTIN cannot contain spaces.
  </p>
)}
</div>
<footer className="mt-6 flex justify-end gap-3">

      <button
        type="button"
        onClick={()=>GstinCheck()}
        className="btn btn-primary"
      >
        Submit
      </button>
    </footer>
</>)}
</div>
    )
}
const CartDetail = () => {
    const dispatch = useDispatch();
    // const items = useSelector((state) => state.cart.items);
    // const cost = useSelector((state) => state.cart.cost);
    // const wallet=useSelector(state=>state.cart.wallet);
    const User = useSelector(state => state.User)
    const [loading, setLoading]=useState(false)
    const razorpay = useRazorpayPayment(User.id, setLoading);
    const UserDetails=useSelector(state=>state.cart.user)
    const {status}=useSelector(state=>state.cart)
    const[items, setItems]=useState([])
    const[cost, setCost]=useState("");
    const[wallet, setWallet]=useState("");
    const [UserCart, setCartUser]=useState("")
    const[cartLoading, setCartLoading]=useState(false)
    const [gstinPopup, setGstinPopup]=useState(false)

    const [enterGstIn, setEnterGstIn]=useState(false)
    const [ChangeGSTINPopup, setChangeGSTINPopup]=useState(false)
    const walletDetails = useSelector((state) => state.cart.wallet)
    const navigate = useNavigate()
    useEffect(() => {
        dispatch(fetchCart(User.user_id));
        getCartDetails()
    }, [User?.user_id]);

    useEffect(()=>{
        
        if(UserCart.is_b2c==false && UserCart.gstin_active==false && UserCart.is_offshore==false){
                    setGstinPopup(true)

        }

    },[UserCart?.gstin_active])
    const getCartDetails=()=>{
        setCartLoading(true)
        API.get(`api/v1/payment/get-cart-details/${User.user_id}`)
        .then(res=>{
            if(res.data.status==200){
                setCartLoading(false)
                setItems(res.data.data.items)
                setCost(res.data.data.cost)
                setWallet(res.data.data.wallet)
                setCartUser(res.data.data.user)
            }
            
        })
        .catch(err=>{
            setCartLoading(false)
            cogoToast.error("Something Went wrong in getting details")
            AuthConsole(err);
            
            
        })
    }
    const removeItemFromCart = (item) => {
        let data = {
            "user_id": User.user_id,
            "cart_item_id": item.item_id
        };

        fetch(BASE_URL + REMOVE_FROM_CART, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error("Failed to remove item from cart");
                }
                return response.json();
            })
            .then(() => {
                dispatch(fetchCart(User.user_id))
                dispatch(removeItem(item));
                getCartDetails()
            })
            .catch(() => {
                cogoToast.info(MESSAGE.DEFAULT_ERROR_MESSAGE);
            });
    };
    const initiateRazorpayPayment = async (amount,id) => {
            setLoading(true)
            try {
                const response = await fetch(`${BASE_URL}${ADD_MONEY}`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        user_id: User.user_id,
                        amount
                    })
                });
    
                const order = await response.json();
                if (!response.ok) {
                    setLoading(false)
                    throw new Error(order.message || "Failed to initiate payment");
                }
                return new Promise((resolve, reject) => {
                    const options = {
                        key: order.data.key_id,
                        amount: order.data.amount,
                        currency: "INR",
                        name: "AuthNumber",
                        description: order.data.description,
                        order_id: order.data.razorpay_order_id,
                        handler: async function (response) {
                            // Step 3: Verify Payment on Backend
                            const verifyResponse = await fetch(`${BASE_URL}${VERIFY_WALLET}`, {
                                method: "POST",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify({
                                    user_id: User.user_id,
                                    razorpay_order_id: response.razorpay_order_id,
                                    razorpay_payment_id: response.razorpay_payment_id,
                                    razorpay_signature: response.razorpay_signature
                                })
                            });
    
                            const result = await verifyResponse.json();
                            if (verifyResponse.ok) {
                                setLoading(false)
                                resolve(true); // Payment success
                            } else {
                                setLoading(false)
                                resolve(false); // Payment failed
                            }
                        },
                        modal: {
                            ondismiss: function () {
                              setLoading(false);
                            }
                          },
                        prefill: {
                            name: UserDetails?.name,
                            email: UserDetails?.email,
                            contact: UserDetails?.phone_number
                        },
                        theme: { color: "#3399cc" }
                    };
    
                    const rzp1 = new window.Razorpay(options);
                    rzp1.open();
                });
            } catch (error) {
                setLoading(false)
                console.error("Payment initiation error:", error);
                return false;
            }
        }
    const AddMoneyToWallet = async (cost) => {
        if (cost >= 1 && cost <=250000) {
            const response = await initiateRazorpayPayment(cost, User.user_id);
            if (response) {
                // window.location.reload()
                Checkout()
            }
            else {
                cogoToast.error(MESSAGE.DEFAULT_ERROR_MESSAGE)
            }
        }
        else {
            cogoToast.error(`Invalid amount! You can add between ${ walletDetails.currency=="USD"?'$1':'₹1'} to ${ walletDetails.currency=="USD"?'$100':'₹25000'}`)
        }
    }
    const Checkout = async (cost) => {
        setLoading(true)
        if(cost>=1){
            AddMoneyToWallet(cost)
        }
        else{
            let api_data = {
                user_id: User.user_id,
                verifier_id: User.id,
                description: "Wallet Payment"
            }
            API.post(PAYMENT_VIA_WALLET, api_data)
                .then(res => {
                    if (res.status == 200) {
                        setLoading(false)
                        navigate('/dashboard/success', { state: true })
                    }
                    else {
                        setLoading(false)
                        navigate('/dashboard/success', { state: false })
                    }
                })
                .catch(err => {
                    setLoading(false)
                    AuthConsole(err)
                    let error = err.response.data.message
                    cogoToast.error(error)
                    // try {
                    //     error = error.errors
                    //     const errorKeys = Object.keys(error)
                    //         .map(key => key.replace(/_/g, ' ')) // Replace underscores with spaces
                    //         .join(', ');
                    //     cogoToast.error(errorKeys + " are invalid")
                    // }
                    // catch (e) {
                    //     cogoToast.error(err.response.data.detail[0].error || "An error occurred")
                    // }
                })
            }
        // }

    }
    const emptyCart=()=>{
        API.delete(EMPTY_CART +"?user_id=" + User.user_id)
        .then(res=>{
            cogoToast.success("Cart empty successfully")
            dispatch(fetchCart(User.user_id))
            
        })
        .catch(err=>{
            cogoToast.error(err.response.data.message)         
        })
    }
    const RemoveCartItem=(item)=>{
            const { hide } = cogoToast.info(<div>
              <button className='btn btn-primary fnt-12' onClick={() => removeItemFromCart(item)}>Yes</button>
              <button className='btn btn-secondary ml-4 fnt-12'>No</button>
            </div>, {
              hideAfter: 10,
              heading: 'Please Confirm to Delete',
              onClick: () => { hide() }
            })
    }
    return (
        <SlideUpWrapper>
            <AnimatedLoader isOpen={loading} loadingText={"Processing your payment"}/>
            <TopTitleBar isChild ><h2 className="topTitleBarText"><span className='secondaryButton1'><Navigate icon={androidArrowBack} size={'1.2rem'} onClick={() => navigate(User.category=="EMPLOYMENT"?'/dashboard/emp/search':"/dashboard/forms/selectForms")} style={{ cursor: 'pointer', marginRight:"10px" }} />Your Cart</span></h2></TopTitleBar>
            <section className="table-header6 " style={{ justifyContent: "space-between", alignItems: 'flex-start' }}>
                {cartLoading?<>
                <div className="credentials-table" style={{ width: '74%' }}>
                <table style={{border:"1px solid lightgray", borderRadius:"10px"}}>
                <tr className="credentials-header1">
                <td className="credentials-th">
                    <div className="shimmer" style={{width:"5rem"}}></div>
                </td>
                {/* <td className="credentials-th">

                    <div>{item.holder_email}</div>
                </td> */}
                <td className="credentials-th">

                <div className="shimmer" style={{width:"5rem"}}></div>
                </td>
                <td className="credentials-th">
                <div className="shimmer" style={{width:"5rem"}}></div>
                </td>
                <td className="credentials-th">
                <div className="shimmer" style={{width:"5rem"}}></div>
                </td>
                <td className="credentials-th">
                <div className="shimmer" style={{width:"2em"}}></div>
                </td>
            </tr>
            </table>
            </div>
            <div style={{ width: '25%' }}>
            <div style={{marginBottom:"10px",backgroundColor:"#F0F1F4", borderRadius:"10px",padding:"32px"}}>
                <div style={{display:"flex",alignItems:"center", justifyContent:"center", gap:"7px", marginBottom:"7px"}}>
                    <div><img src="/cart.svg" alt="cart.svg"/></div>
                    <div style={{fontWeight:"600", fontSize:"16px"}}>Cart Summary</div>
                </div>
                <div style={{textAlign:"center"}}>{items.length} Items</div>
                <table>

                    <tr>
                        <td className="issuer-label">Base Price</td>
                        <td className="issuer-label"><div className="shimmer" style={{width:"5rem"}}></div></td>
                    </tr>
                    <tr>
                        <td className="issuer-label">Taxes</td>
                        <td className="issuer-label"><div className="shimmer" style={{width:"5rem"}}></div></td>
                    </tr>
                {cost.cgst>0.0 &&    <tr>
                        <td style={{paddingLeft:"1.5rem", color:"gray"}}><div className="shimmer" style={{width:"5rem"}}></div></td>
                        <td className="issuer-label" style={{color:"gray"}}><div className="shimmer" style={{width:"5rem"}}></div></td>
                    </tr>}

                {cost.sgst>0.0 &&    <tr>
                        <td style={{paddingLeft:"1.5rem",color:"gray"}}><div className="shimmer" style={{width:"5rem"}}></div></td>
                        <td className="issuer-label" style={{color:"gray"}}><div className="shimmer" style={{width:"5rem"}}></div></td>
                    </tr>}
                    {cost.igst>0.0 && 
                        <tr>
                            <td style={{paddingLeft:"1.5rem", color:"gray"}}><div className="shimmer" style={{width:"5rem"}}></div></td>
                            <td className="issuer-label" style={{color:"gray"}}><div className="shimmer" style={{width:"5rem"}}></div></td>
                        </tr>
                    
                    }
                    <tr>
                        <td className="issuer-label">SubTotal</td>
                        <td className="issuer-label"><div className="shimmer" style={{width:"5rem"}}></div></td>
                    </tr>
                    <tr>
                        <td className="issuer-label" style={{color:"#00B25C"}}>Wallet Deduction</td>
                        <td className="issuer-label" style={{color:"#00B25C"}}><div className="shimmer" style={{width:"5rem"}}></div></td>
                    </tr>
                    <hr style={{width:"200%", backgroundColor:"#666666"}}/>
                    <tr>
                        <td className="issuer-label" style={{fontSize:"16px", fontWeight:"600"}}>Total Payable</td>
                        <td className="issuer-label" style={{fontSize:"16px", fontWeight:"600"}}><div className="shimmer" style={{width:"5rem"}}></div></td>
                    </tr>
                </table>
                <div style={{display:"flex", alignItems:"center", justifyContent:"center", marginTop:"15px", flexDirection:"column", gap:"1rem"}}>
                <div style={{display:"flex", justifyContent:"center", gap:"1px"}}><div style={{color:"gray", fontWeight:"600"}}>Note:</div><div style={{textAlign:"center", color:"gray"}}>Transaction platform fee may apply based on your chosen payment method and may not reversed</div></div>
            </div>
            </div>
            </div>
            </>
            :items.length === 0 ? (
                <>
                    <p className="text-gray-600" style={{fontSize:"18px"}}>Your cart is empty.</p>
                    <button className="btn btn-primary" onClick={() => navigate(User.category=="EMPLOYMENT"?"/dashboard/emp/search":"/dashboard/forms/selectForms")}>Add Items</button>
                </>
            ):
                (
                    <div className="credentials-table" style={{ width: '74%' }}>
                        <table style={{border:"1px solid lightgray", borderRadius:"10px"}}>
                            <thead>
                                <tr className="credentials-header bg-lgray">
                                {User.category=="EMPLOYMENT"&&    <th className="credentials-th">
                                        <div className="credentials-table-text">Company Name</div>
                                    </th>}
                                    {/* <th className="credentials-th">
                                        <div className="credentials-table-text">Holder Email</div>
                                    </th> */}
                                    <th className="credentials-th">
                                        <div className="credentials-table-text">Holder Name</div>
                                    </th>
                                    <th className="credentials-th">

                                        <div className="credentials-table-text">{User.category=="EMPLOYMENT"?"Document Name":"Form Name"}</div>
                                    </th>
                                    <th className="credentials-th">

                                        <div className="credentials-table-text">Charges</div>
                                    </th>
                                    <th className="credentials-th">

                                        <div className="credentials-table-text">Action</div>
                                    </th>
                                </tr>
                            </thead>
                            {/* <tbody className='Table-Content' style={items.length <= 6 ? { overflowY: "hidden" } : null}> */}

                            {items.map((item) => (
                                <tr className="credentials-header1" key={item.item_id}>
                                {User.category=="EMPLOYMENT"&&    <td className="credentials-th">
                                        <div>{item.issuer_company_name}</div>
                                    </td>}
                                    {/* <td className="credentials-th">

                                        <div>{item.holder_email}</div>
                                    </td> */}
                                    <td className="credentials-th">

                                        <div>{item.holder_name}</div>
                                    </td>
                                    <td className="credentials-th">
                                        <div>{item.document_name}</div>
                                    </td>
                                    <td className="credentials-th">
                                        <div>{item.cost}</div>
                                    </td>
                                    <td className="credentials-th">
                                        <div>
                                            <button className="btn" onClick={() => RemoveCartItem(item)}><Icon icon={androidDelete} /></button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            {/* </tbody> */}
                            {/* <hr /> */}
                            <div style={{
                                width: "-webkit-fill-available",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}>
                                <button className='btn add-more1' onClick={e => navigate(User.category=="EMPLOYMENT"?"/dashboard/emp/search":"/dashboard/forms/selectForms")} >+ Add</button>
                            </div>
                        </table>

                    </div>
                )}
                {cartLoading || status=="loading"?null:items.length > 0 &&
                    <div style={{ width: '25%' }}>
                        <div style={{marginBottom:"10px",backgroundColor:"#F0F1F4", borderRadius:"10px",padding:"32px"}}>
                            <div style={{margin:"0px",textAlign:"center", fontSize:"16px", fontWeight:"700"}}>Invoice Details</div>
                            <table>
                            <tr>
                                    <td className="issuer-label">GSTIN <span style={{color:"#1c64f2", cursor:"pointer"}} onClick={()=>setChangeGSTINPopup(true)}>{`(Change)`}</span></td>
                                    <td className="issuer-label">{UserDetails.default_gstin}</td>
                                </tr>
                            {/* <tr>
                                    <td className="issuer-label">Company Name</td>
                                    <td className="issuer-label">{UserDetails.name}</td>
                                </tr> */}
                            <tr>
                                    <td className="issuer-label">User Type</td>
                                    <td className="issuer-label">{UserDetails.isb2c?"B2C":UserDetails.is_offshore?"OffShore":"B2B"}</td>
                                </tr>
                                </table>
                        </div>
                        <div style={{marginBottom:"10px",backgroundColor:"#F0F1F4", borderRadius:"10px",padding:"32px"}}>
                            <div style={{display:"flex",alignItems:"center", justifyContent:"center", gap:"7px", marginBottom:"7px"}}>
                                <div><img src="/cart.svg" alt="cart.svg"/></div>
                                <div style={{fontWeight:"600", fontSize:"16px"}}>Cart Summary</div>
                            </div>
                            <div style={{textAlign:"center"}}>{items.length} Items</div>
                            <table>

                                <tr>
                                    <td className="issuer-label">Base Price</td>
                                    <td className="issuer-label">{`${wallet.currency=="USD"?"$":"₹"}${cost.base_rate}`}</td>
                                </tr>
                                <tr>
                                    <td className="issuer-label">Taxes</td>
                                    <td className="issuer-label">{`${wallet.currency=="USD"?"$":"₹"}${cost.tax}`}</td>
                                </tr>
                            {cost.cgst>0.0 &&    <tr>
                                    <td style={{paddingLeft:"1.5rem", color:"gray"}}>CGST(9%)</td>
                                    <td className="issuer-label" style={{color:"gray"}}>₹{cost.cgst}</td>
                                </tr>}

                            {cost.sgst>0.0 &&    <tr>
                                    <td style={{paddingLeft:"1.5rem",color:"gray"}}>SGST(9%)</td>
                                    <td className="issuer-label" style={{color:"gray"}}>₹{cost.sgst}</td>
                                </tr>}
                                {cost.igst>0.0 && 
                                    <tr>
                                        <td style={{paddingLeft:"1.5rem", color:"gray"}}>IGST(18%)</td>
                                        <td className="issuer-label" style={{color:"gray"}}>₹{cost.igst}</td>
                                    </tr>
                                
                                }
                                <tr>
                                    <td className="issuer-label">SubTotal</td>
                                    <td className="issuer-label">{`${wallet.currency=="USD"?"$":"₹"}${cost.total_amount_payable}`}</td>
                                </tr>
                                <tr>
                                    <td className="issuer-label" style={{color:"#00B25C"}}>Wallet Deduction</td>
                                    <td className="issuer-label" style={{color:"#00B25C"}}>{`-${wallet.currency=="USD"?"$":"₹"}${cost.wallet_adjustment}`}</td>
                                </tr>
                                <hr style={{width:"200%", backgroundColor:"#666666"}}/>
                                <tr>
                                    <td className="issuer-label" style={{fontSize:"16px", fontWeight:"600"}}>Total Payable</td>
                                    <td className="issuer-label" style={{fontSize:"16px", fontWeight:"600"}}>{`${wallet.currency=="USD"?"$":"₹"}${cost.final_amount}`}</td>
                                </tr>
                            </table>
                            <div style={{display:"flex", alignItems:"center", justifyContent:"center", marginTop:"15px", flexDirection:"column", gap:"1rem"}}>
                            {
                                items.length === 0 ? <button className="btn btn-primary">Add Items</button> :
                                    <>
                                        {/* <button className="btn" onClick={() => emptyCart()}>
                                            Empty Cart
                                        </button> */}

                                        <button className="btn btn-primary" style={{display:"flex", alignItems:"center", justifyContent:"center", width:"100%"}} onClick={() => Checkout(cost.final_amount)}>

                                        {cost.final_amount>0?<div>Recharge Wallet</div>:    <div>Proceed To Checkout</div>}
                                            <img src="/chevronRight.svg" alt="chevronRight.svg"/>
                                        </button>
                                    </>
                            }
                            <div style={{display:"flex", justifyContent:"center", gap:"1px"}}><div style={{color:"gray", fontWeight:"600"}}>Note:</div><div style={{textAlign:"center", color:"gray"}}>Transaction platform fee may apply based on your chosen payment method and may not reversed</div></div>
                        </div>
                        </div>

                    </div>}

            </section>
            <ReactPortalModal isOpen={gstinPopup} title="GSTIN UPDATE" blockOutsideClick={true} onClose={()=>setGstinPopup(true)} showClose={false}>
                            <AddGstIn enterGstIn={enterGstIn} setEnterGstIn={setEnterGstIn} setGstinPopup={setGstinPopup}/>
            </ReactPortalModal>
            <ReactPortalModal isOpen={ChangeGSTINPopup} title="GSTIN UPDATE" blockOutsideClick={true} onClose={()=>setChangeGSTINPopup(false)}>
                            <AddDefaultGstIn setGstinPopup={setChangeGSTINPopup}/>
            </ReactPortalModal>
        </SlideUpWrapper>
    );
};

export default CartDetail;
